import { Box, Button, Card, FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import CustodianDetailsHeaderModel from '../../../Models/custodian/custodian-details-header';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

import {
  addressBox,
  boldLabel,
  creationDateContainer,
  custodianName,
  custodianNameWrapper,
  flexRow,
  flexRowSpaceBetween,
  headerContainer,
  headerInfoBoxText,
  iconLabel,
  iconText,
  paddedIcon,
  phoneBox,
  portalUrlBox,
} from '../Styles/CustodianDetailsHeaderStyles';
import { useState } from 'react';

export default function CustodianDetailsHeader({
  headerInfo,
  isVisibleEdit,
  setIsVisibleEdit
}: {
  headerInfo: CustodianDetailsHeaderModel;
  isVisibleEdit: boolean;
  setIsVisibleEdit: (val: boolean) => void;
}) {
  return (
    <Card sx={headerContainer}>
      <Box sx={flexRowSpaceBetween}>
        <Box sx={custodianNameWrapper}>
          <Typography align="left" sx={custodianName}>
            {headerInfo.name}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
